import {
  ComponentInternalInstance,
  ComputedRef,
  Ref,
  UnwrapRef,
  computed,
  getCurrentInstance,
  reactive,
  ref,
} from '@vue/composition-api';
import tips from '@/renderer/scripts/utils/tips';
import smh, { SMH } from '@/renderer/scripts/smh';
import i18n, { i18n_t } from '@/locales/i18n';

export type ListItem = SMH.StencilListContent & {
  checked: boolean;
};
type StencilDataType = {
  marker: number;
  hasmore: boolean;
  limit: number;
  totalNum: number;
  stencilList: ListItem[];
};

type Handler = {
  loading: Ref<Boolean>;
  isSearching: Ref<Boolean>;
  templateName: Ref<String>;
  fileType: Ref<String>;
  fileTypeSelect: Array<any>;
  selectedList: ComputedRef<Array<ListItem>>;
  initSelectedList: Ref<Array<ListItem>>;
  stencilData: UnwrapRef<StencilDataType>;
  stencilMenu: Ref<Array<SMH.StencilTypeData>>;
  methods: {
    stencilPullType: () => Promise<void>;
    stencilPullList: (templateType: string) => Promise<void>;
    onSearch: () => Promise<void>;
  };
};

// 弹窗模板处理handler
export default function stencilHandler(location = 'space'): Handler {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;

  const fileTypeSelect = [
    {
      label: i18n_t('全部格式'),
      value: 'all',
      icon: 'other',
    },
    {
      label: i18n_t('文档'),
      value: 'word',
      icon: 'word',
    },
    {
      label: i18n_t('表格'),
      value: 'excel',
      icon: 'excel',
    },
    // TODO: 本期无演示文稿 先隐藏
    // {
    //   label: i18n_t('演示文稿'),
    //   value: 'powerpoint',
    //   icon: 'powerpoint',
    // },
  ];

  const loading = ref(false);
  const isSearching = ref(false);
  const templateName = ref('');
  const fileType = ref('all');

  const stencilData = reactive<StencilDataType>({
    marker: 0,
    hasmore: false,
    // TODO: 目前文件量可直接传limit为100
    limit: 100,
    totalNum: 0,
    stencilList: [],
  });

  // 已选择模板列表
  const initSelectedList: Ref<ListItem[]> = ref([]);
  const selectedList = computed(() => {
    let temselectedList = [];
    // 将各分类已选择移入已选择
    temselectedList = stencilData.stencilList.filter((item: ListItem) => item.checked === true);
    initSelectedList.value.push(...temselectedList);
    // 将已存的initSelectedList但取消勾选进行移除
    initSelectedList.value = initSelectedList.value.filter((item: ListItem) => item.checked === true);
    // 针对id相同进行去重操作
    initSelectedList.value = Array.from(
      initSelectedList.value.reduce((map, item) => map.set(item.id, item), new Map()).values(),
    );

    return initSelectedList.value;
  });

  const stencilMenu: Ref<SMH.StencilTypeData[]> = ref([
    {
      templateTypeCN: '',
      templateType: '',
    },
  ]);

  const methods = {
    async stencilPullType() {
      try {
        const { data: listRes } = await smh.commonAPI.getStencilType({
          spaceId: vm.$route.query?.spaceId as string,
          spaceOrgId: Number(vm.$route.query?.spaceOrgId) || vm.$store.getters.orgId,
        });
        stencilMenu.value = listRes;
      } catch (err: MsgError) {
        if (!['SpaceNotFound', 'NoSpace'].includes(err.code)) {
          tips.error(err as MsgError);
        }
        stencilMenu.value = [];
      }
    },
    async stencilPullList(templateType: string) {
      const stencilListParams = {
        // 若调用位置在空间下拉选择导入模板则传入1，新建群组默认显示模板传2
        flag: location === 'space' ? 1 : 2,
        limit: stencilData.limit,
        templateName: templateName.value,
        fileType: fileType.value === 'all' ? '' : fileType.value,
        templateType: templateType === 'all' ? '' : templateType,
        spaceId: vm.$route.query?.spaceId as string,
        spaceOrgId: Number(vm.$route.query?.spaceOrgId) || vm.$store.getters.orgId,
      };
      if (stencilData.marker !== 0) {
        Object.assign(stencilListParams, {
          marker: stencilData.marker,
        });
      }
      try {
        loading.value = true;
        const { data: listRes } = await smh.commonAPI.getStencilList(stencilListParams);
        stencilData.stencilList = listRes.contents.map(item1 => {
          // 判断是否已勾选
          const selectData = selectedList.value.find(item2 => item2.id === item1.id);
          return { ...item1, checked: !!selectData };
        });
        loading.value = false;
      } catch (error) {
        loading.value = false;
        tips.error(error as MsgError);
      }
    },
    async onSearch() {
      stencilData.marker = 0;
      isSearching.value = true;
      // 搜索时查询的全部类目下的数据
      await methods.stencilPullList('all');
    },
  };

  return {
    loading,
    isSearching,
    templateName,
    fileType,
    fileTypeSelect,
    stencilMenu,
    selectedList,
    stencilData,
    initSelectedList,

    methods,
  };
}
